import React from "react";
import { DotLottieReact } from "@lottiefiles/dotlottie-react";
import animationData from "../../../assets/spinner/SSFSpinnerReverse.json";

function SpinnerContainerOverlay() {
  return (
    <div className="d-flex justify-content-center align-items-center blurry-background">
      <DotLottieReact
        data={animationData}
        loop={true}
        autoplay={true}
        speed={2}
        className="spinner-size"
      />
    </div>
  );
}

export default SpinnerContainerOverlay;
